import React, { FC } from 'react'
import { PolaroidList } from 'components/SA/Polaroid'
import ListConnector, { ConnectorProps as ListProps } from '../../connectors/List'
import styles from './FeaturePolaroidList.module.scss'
import { useSelector } from 'react-redux'
import { getAlgoliaDataHitsTotal } from 'selectors/algolia2/data'

type FeaturePolaroidListProps = ListProps & {
  isAlgoliaLoading?: boolean
  searchQuery: string | null
  title: string
}

const FeaturePolaroidList: FC<FeaturePolaroidListProps> = ({
  algoliaIndice,
  algoliaUserToken,
  artworks,
  isScreenReady,
  userID,
  title,
  searchQuery,
  isAlgoliaLoading,
}) => {
  const dataLayerListName = searchQuery ? `Results for "${searchQuery}"` : title
  const totalNumberOfResults = useSelector(getAlgoliaDataHitsTotal)

  const handleCheckIsPrintForDataLayerEvent = ({ hasOpenEditions }) => hasOpenEditions

  return (
    <PolaroidList
      algoliaIndice={algoliaIndice}
      algoliaUserToken={algoliaUserToken}
      dataApi='algolia'
      dataList='feature-results'
      dataListId='feature-results'
      dataListName={dataLayerListName}
      artworks={artworks}
      isLoading={!isScreenReady || isAlgoliaLoading}
      userID={userID}
      isPrintsFromVisible={false}
      onCheckIsPrintForDataLayerEvent={handleCheckIsPrintForDataLayerEvent}
      skeletonQuantity={100}
      customStyle={styles.customPolaroidListContainer}
      searchProviderAttributes={[
        { 'browse-container': true },
        { 'total-number-results': totalNumberOfResults },
        { 'filter-name': false },
        { 'filter-value': false },
      ]}
    />
  )
}

export default ListConnector(FeaturePolaroidList)
